import { createRequest, RequestConfig } from 'app/common/api';

import { TTerminalProfile } from '../core/profiles';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_terminal_profile',
};

type GetTerminalProfileRequestParams = {
  id: TTerminalProfile['id'];
};

export const getTerminalProfileRequest = ({
  id,
}: GetTerminalProfileRequestParams) =>
  createRequest({
    url: config.url,
    method: config.method,
    query: { id: String(id) },
  });
